import React from "react";
import Template from "./components/template";

function App() {
  return (
    <Template/>
  );
}

export default App;
